let timerId: any;
function debounce(callback: () => void, wait: number) {
  return () => {
    if (timerId) {
    } else {
      timerId = setTimeout(() => {
        console.log("deebounce");
        callback();
        clearTimeout(timerId);
        timerId = undefined;
      }, wait);
    }
  };
}

function debounceRunFirst(callback: () => void, wait: number) {
  return () => {
    if (timerId) {
    } else {
      timerId = setTimeout(() => {
        console.log("deebounce");
        clearTimeout(timerId);
        timerId = undefined;
      }, wait);
      callback();
    }
  };
}

export { debounce, debounceRunFirst };
